import DeleteMyData from './DeleteMyData';

export default DeleteMyData;